export const isFunction = functionToCheck =>
  functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'



// WEBPACK FOOTER //
// ./src/utils/index.js